import React from 'react';
import { useParams } from 'react-router-dom';
import { useParcelByPin } from '../hooks';
import ParcelDetailsView from './ParcelDetailsView';


const ParcelDetailsByPin: React.FC = () => {
  const { pin } = useParams();
  const { parcel, error, isLoading } = useParcelByPin(pin);

  if (!parcel && error && 'status' in error) {
    console.error('fetch error', error)
  }

  return <ParcelDetailsView parcel={parcel} isLoading={isLoading} />
};

export default ParcelDetailsByPin;